module.exports = __webpack_public_path__ + "img/logo-typo-dark.a1da52ba.svg";